import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Gallery from './components/Gallery/Gallery';
import PriceList from './components/PriceList/PriceList';
import Commission from './components/Commission/Commission';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Legal from './components/Legal/Legal';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/prices" element={<PriceList />} />
            <Route path="/Commission" element={<Commission />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;